const RELOAD_KEY = "chunkReloadTimestamp";
const RELOAD_WINDOW = 5000;

export const isChunkLoadError = (error: any): boolean => {
    if (!error) return false;
    if (error.name === "ChunkLoadError") return true;
    const message = typeof error.message === "string" ? error.message : String(error);
    return (
        /Loading chunk \d+ failed/.test(message) ||
        /Failed to fetch dynamically imported module/.test(message)
    );
};

/**
 * A page left open across a deploy asks for a chunk file that no longer exists. One
 * reload fixes it - and only one: the timestamp guard stops a broken deploy from
 * putting the browser in a reload loop.
 */
export const tryReloadOnChunkLoadError = (error: any): boolean => {
    if (!isChunkLoadError(error)) return false;
    try {
        const lastReload = window.sessionStorage.getItem(RELOAD_KEY);
        if (lastReload && Date.now() - parseInt(lastReload, 10) < RELOAD_WINDOW) {
            return false;
        }
        window.sessionStorage.setItem(RELOAD_KEY, Date.now().toString());
    } catch {
        // sessionStorage may be unavailable
    }
    const loc = window.location;
    const separator = loc.search ? "&" : "?";
    window.location.href = loc.pathname + loc.search + separator + "_reload=" + Date.now() + loc.hash;
    return true;
};
